import { DASHBOARD } from "../actionTypes";

const initialState = {
    newProducts: [],
};

const newProductsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case DASHBOARD.GET_NEW_PRODUCTS:
            return {
                ...state,
                newProducts: [{
                    id: 1,
                    content: "Latest Flexi Cap",
                    btn_content: "view"
                }, {
                    id: 2,
                    content: "Analyze Your Portfolio",
                    btn_content: "Try Now !"
                }, {
                    id: 3,
                    content: "Get Best Mutual fund Recommendation's",
                    btn_content: "Subscribe"
                }, {
                    id: 4,
                    content: "Latest Flexi Cap",
                    btn_content: "view"
                }, {
                    id: 5,
                    content: "Analyze Your Portfolio Health",
                    btn_content: "Try Now!"
                }, {
                    id: 6,
                    content: "Hi please subscrive",
                    btn_content: "Subscribe"
                }, {
                    id: 7,
                    content: "Latest Flexi Cap",
                    btn_content: "view"
                }, {
                    id: 8,
                    content: "Analyze Your Portfolio",
                    btn_content: "Try Now !"
                }, {
                    id: 9,
                    content: "Get Best Mutual fund Recommendation's",
                    btn_content: "Subscribe"
                },]
            };

        default:
            return state;
    }

};

export default newProductsReducer;